import Auth from './auth/reducer';
import App from './app/reducer';
import Box from './box/reducer';
import Contacts from './contacts/reducer';
import Company from './company/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';

export default {
  Auth,
  App,
  LanguageSwitcher,
  Box,
  Contacts,
  Company,
};



// WEBPACK FOOTER //
// ./src/redux/reducers.js